import Cookies from 'js-cookie'
let COOKIE_KEY_ACCESS = "token"
export function getToken() {
    return Cookies.get(COOKIE_KEY_ACCESS)
}

export function setToken(token) {
    // console.log('存储成功')
    return Cookies.set(COOKIE_KEY_ACCESS, token, { expires: 280000 })
}

export function removeToken() {
    return Cookies.remove(COOKIE_KEY_ACCESS)
}




let COOKIE_KEY_ACCESS2 = "user"
export function getUser() {
    return Cookies.get(COOKIE_KEY_ACCESS2)
}

export function setUser(user) {
    // console.log('存储成功')
    return Cookies.set(COOKIE_KEY_ACCESS2, user, { expires: 280000 })
}

export function removeUser() {
    return Cookies.remove(COOKIE_KEY_ACCESS2)
}




let COOKIE_KEY_ACCESS3 = "selectedTimezone"
export function getSelectedTimezone() {
    return Cookies.get(COOKIE_KEY_ACCESS3)
}

export function setSelectedTimezone(selectedTimezone) {
    return Cookies.set(COOKIE_KEY_ACCESS3, selectedTimezone, { expires: 280000 })
}

export function removeSelectedTimezone() {
    return Cookies.remove(COOKIE_KEY_ACCESS3)
}